import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  CzescBudynku,
  czescBudynkuResource,
} from "@megarax/client/src/resources/plm";

export const czescBudynkuModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Części budynku",
  route: "czescBudynku",
  itemConstructor: CzescBudynku,
  resource: czescBudynkuResource,
};
